// Omnix/client/ui/OmnixAssistantWidget.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class OmnixAssistantWidget extends ComponentBase {
    static styles = `
        .omnix-assistant-fab {
            position: fixed;
            bottom: 20px;
            right: 20px;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: var(--bs-primary);
            color: var(--bs-primary-contrast, #fff);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.8rem;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            cursor: pointer;
            z-index: 1040;
            transition: transform 0.2s ease-in-out;
        }
        .omnix-assistant-fab:hover {
            transform: scale(1.1);
        }
        /* --- START OF CSS MODIFICATION --- */
        .omnix-assistant-modal .modal-dialog {
            max-width: 600px;
            height: 80vh; /* Set a max height for the dialog */
            margin: 1.75rem auto; /* Standard Bootstrap margin */
        }
        .omnix-assistant-modal .modal-content {
            height: 100%; /* Fill the dialog height */
            display: flex; /* Enable flexbox */
            flex-direction: column; /* Stack header, body, footer */
        }
        .omnix-assistant-modal .modal-body {
            padding: 0; /* AiCoPilot will manage its own padding */
            flex-grow: 1; /* Allow body to take up remaining space */
            overflow: hidden; /* Prevent body from overflowing content */
        }
        /* --- END OF CSS MODIFICATION --- */
    `;

    constructor(config) {
        super(config);
        this.modalInstance = null;
        this.coPilot = null;
        this.applyStyles();
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'omnix-assistant-widget-container';

        this.modalElement = document.createElement('div');
        this.modalElement.className = 'modal fade omnix-assistant-modal';
        this.modalElement.id = `${this.config.instanceId}-modal`;
        this.modalElement.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Omnix Assistant</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body" id="${this.config.instanceId}-copilot-body"></div>
                </div>
            </div>
        `;
        document.body.appendChild(this.modalElement);
        this.modalInstance = new bootstrap.Modal(this.modalElement);

        this.coPilot = await this.createManagedComponent('AdvancedAIWorkspace', `#${this.config.instanceId}-copilot-body`, {
            instanceId: `${this.config.instanceId}-copilot`,
            agentName: 'OmnixAssistant',
            singleAgentMode: true,
            height: 'container',
        });

        await super.initialize();
    }

    render() {
        this.container.innerHTML = `
            <div class="omnix-assistant-fab" title="Open Omnix Assistant">
                <i class="bi bi-robot"></i>
            </div>
        `;
        this.container.querySelector('.omnix-assistant-fab').addEventListener('click', () => {
            this.modalInstance.show();
        });
        return this.container;
    }

    destroy() {
        this.modalInstance?.dispose();
        this.modalElement?.remove();
        this.coPilot?.destroy();
        super.destroy();
    }
}